import script from "./addtocart.vue?vue&type=script&setup=true&lang=js"
export * from "./addtocart.vue?vue&type=script&setup=true&lang=js"

import "./addtocart.vue?vue&type=style&index=0&id=77f5c322&lang=css"

const __exports__ = script;

export default __exports__